module.exports = __webpack_public_path__ + "static/board-18-4de2bdfc76e48ad9e133eb5615963e20.jpg";